module.exports = __webpack_public_path__ + "img/stage.71725974.jpg";